import { CreateActionsDropdown } from './CreateActionsDropdown';
import { WorkoutsTabs } from './WorkoutsTabs';
import { TitledPage } from '@client/new/components/Misc';

export function WorkoutsPage({ isLoading, creator, children }) {
  const title = 'Workouts';

  return (
    <TitledPage
      title={title}
      rightContent={
        <CreateActionsDropdown
          influencerId={creator.id}
          selectedProgramId={null}
        />
      }
    >
      <div>
        <WorkoutsTabs creatorId={creator.id} />
        {isLoading && <div>Loading...</div>}
        {!isLoading && <div className="newWorkoutList">{children}</div>}
      </div>
    </TitledPage>
  );
}
